import CriticsPodSource from "components/Critics/PodSource"

import { ComponentProps } from "."
import Overrides from "./Overrides"

const PodSource = ({
  areReviewsLoading,
  isCompact,
  isCreated,
  isLoading,
  isValid,
  label,
  onCancel,
  onClear,
  onSave,
  onSetReleaseDate,
  onUpdateAudio,
  onUpdateExtra,
  onUpdateMovie,
  onUpdateTotal,
  onUpdateVideo,
  review,
  serviceName,
  text
}: ComponentProps) => (
  <CriticsPodSource
    areItemsLoading={areReviewsLoading}
    isCompact={isCompact}
    isCreated={isCreated}
    isLoading={isLoading}
    isValid={isValid}
    itemLabel="Reviews"
    label={label}
    modalContent={
      <Overrides
        onSetReleaseDate={onSetReleaseDate}
        onUpdateAudio={onUpdateAudio}
        onUpdateExtra={onUpdateExtra}
        onUpdateMovie={onUpdateMovie}
        onUpdateTotal={onUpdateTotal}
        onUpdateVideo={onUpdateVideo}
        review={review}
        serviceName={serviceName}
      />
    }
    onCancel={onCancel}
    onClear={onClear}
    onSave={onSave}
    serviceName={serviceName}
    text={text}
  />
)
export default PodSource
